var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0005 0H2.00049C0.900488 0 0.000488281 0.9 0.000488281 2V16C0.000488281 17.1 0.900488 18 2.00049 18H18.0005C19.1005 18 20.0005 17.1 20.0005 16V2C20.0005 0.9 19.1005 0 18.0005 0ZM7.00049 14H4.00049C3.45049 14 3.00049 13.55 3.00049 13C3.00049 12.45 3.45049 12 4.00049 12H7.00049C7.55049 12 8.00049 12.45 8.00049 13C8.00049 13.55 7.55049 14 7.00049 14ZM7.00049 10H4.00049C3.45049 10 3.00049 9.55 3.00049 9C3.00049 8.45 3.45049 8 4.00049 8H7.00049C7.55049 8 8.00049 8.45 8.00049 9C8.00049 9.55 7.55049 10 7.00049 10ZM7.00049 6H4.00049C3.45049 6 3.00049 5.55 3.00049 5C3.00049 4.45 3.45049 4 4.00049 4H7.00049C7.55049 4 8.00049 4.45 8.00049 5C8.00049 5.55 7.55049 6 7.00049 6ZM16.7005 8.12L13.5305 11.29C13.1405 11.68 12.5005 11.68 12.1105 11.29L10.7005 9.87C10.3105 9.48 10.3105 8.85 10.7005 8.46C11.0905 8.07 11.7205 8.07 12.1105 8.46L12.8205 9.17L15.2905 6.7C15.6805 6.31 16.3105 6.31 16.7005 6.7L16.7105 6.71C17.0905 7.1 17.0905 7.74 16.7005 8.12Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/Checklist.d697bc5a5d4618b6b2507f75ff472884.svg";
export { ForwardRef as ReactComponent };